import axiosWithAuth from '../utils/axiosWithAuth';

/**
 * Generate image for specific content
 * @param {number} contentId - The ID of the content to generate image for
 * @returns {Promise<Object>} - Response from the image generation API
 */
export const generateImageForContent = async (contentId) => {
    try {
        console.log('Generating image for content:', contentId);
        const response = await axiosWithAuth.post('/cas/image-generation/generate', {
            content_id: contentId
        });
        console.log('Image generation response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error generating image for content:', error);
        throw error;
    }
};

/**
 * Get image data URL for a specific content
 * @param {number} contentId - The ID of the content
 * @returns {Promise<string>} - Data URL of the generated image
 */
export const getImageDataUrl = async (contentId) => {
    try {
        console.log('Fetching image data URL for content:', contentId);
        const response = await axiosWithAuth.get(`/cas/generated-images/data-url/${contentId}`);
        console.log('Image data URL response:', response.data);
        return response.data.data_url;
    } catch (error) {
        console.error('Error fetching image data URL:', error);
        throw error;
    }
};

/**
 * Get image status for a specific content
 * @param {number} contentId - The ID of the content
 * @returns {Promise<Object>} - Image status information
 */
export const getImageStatus = async (contentId) => {
    try {
        const response = await axiosWithAuth.get(`/cas/generated-images/status/${contentId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching image status:', error);
        throw error;
    }
};

/**
 * Delete generated image for a specific content
 * @param {number} contentId - The ID of the content
 * @returns {Promise<Object>} - Response from the delete API
 */
export const deleteGeneratedImage = async (contentId) => {
    try {
        const response = await axiosWithAuth.delete(`/cas/generated-images/${contentId}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting generated image:', error);
        throw error;
    }
};

/**
 * Get list of content IDs that have generated images
 * @returns {Promise<Array>} - Array of content IDs with images
 */
export const getAvailableImages = async () => {
    try {
        const response = await axiosWithAuth.get('/cas/generated-images/available-images');
        return response.data.content_ids_with_images || [];
    } catch (error) {
        console.error('Error fetching available images:', error);
        return [];
    }
};

/**
 * Generate images for multiple content items
 * @param {Array<number>} contentIds - Array of content IDs to generate images for
 * @returns {Promise<Object>} - Response from the bulk image generation API
 */
export const bulkGenerateImages = async (contentIds) => {
    try {
        console.log('Generating images for content:', contentIds);
        const response = await axiosWithAuth.post('/cas/image-generation/bulk-generate', {
            content_ids: contentIds
        });
        console.log('Bulk image generation response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error bulk generating images:', error);
        throw error;
    }
}; 